import React from "react";
import Button from "react-bootstrap/Button";
import {BsArrowClockwise} from "react-icons/bs";
import {useReload} from "../hooks/useNavigation";

/**
 * Reset Graph Button that reloads the page to the root path. Causes a full page reload.
 */
const ResetGraphButton = React.memo(() => {
  const rootReload = useReload();

  return <Button
    variant="outline-light"
    onClick={rootReload}
    aria-label="Reset Graph"
    title="Reset Graph">
    <BsArrowClockwise className="ui-icon"/>
  </Button>
});

export default ResetGraphButton;